
import TableList from "@components/templates/tablelist";
import { HttpTaskCenterList, HttpTaskCenterAgain } from '@/service/boss/allot';
import { mapState, mapGetters } from "vuex";
import compDetail from '@mods/views/notice/task/detailmodal'
export default {
    mixins: [TableList],
    components: {
        compDetail
    },
    data() {
        return {
            isMixin: true,
            Tools: { show: true },
            Searchs: {
                show: true,
                labelWidth: 90,
            },
            Plugins: { show: true }
        };
    },

    methods: {
        ajaxRequest: HttpTaskCenterList,
        handleOperates(params = "", type, batch) {
            if (batch === true) {
                params = (params || this.checkedData.join(',')) + '';
                if (!params.length) return this.$VMessage.warning('请选择至少一条数据');
            }
            switch (type) {
                case "query":
                    this.operate = {
                        id:params,
                        title: '查看',
                        component: 'compDetail',
                        show: true,
                        width: '55%',
                        showFooter: false,
                        type:'query'
                    };
                    break;
                case "again":
                    this.operate = {
                        show: true,
                        alert: "error",
                        params: {
                            status: 1,
                            ids: params
                        },
                        title: "重试操作",
                        ajaxRequest: HttpTaskCenterAgain
                    }
                    break;
                // case "cancel":
                //     this.operate = {
                //         show: true,
                //         alert: "error",
                //         params: {
                //             status: 1,
                //             ids: params
                //         },
                //         title: "取消操作",
                //         ajaxRequest: HttpTaskCenterCancel
                //     }
                //     break;
                case 'down':
                    this.exportFile(params)
                    break;
            }
        },

        exportFile(params){
            this.handleWebfs(params, {}, "download");
        },

        getOperateNodeMap(row){
            const { id, status } = row
            return [{
                label:'查看',
                show:true,
                params:id,
                operate:'query'
            },{
                label:'重试',
                show: status == 'failed',
                params:id,
                operate:'again',
                batch: true,
                // },{
                //     label:'取消',
                //     show: status == 'failed',
                //     params:id,
                //     operate:'cancel',
                //     batch: true,
            },]
        },
    },
    computed: {
        ...mapState('boss', ['accounts','products','warehouseList','taskServiceAll']),

        ToolsData() {
            return [
                {
                    label: "重试",
                    operate: "again",
                    theme: "primary",
                    batch: true,
                },
                // {
                //     label: "取消",
                //     operate: "cancel",
                //     theme: "error",
                //     batch: true,
                // },
            ]
        },

        SearchsData() {
            // console.log(this.taskServiceAll)
            return [
                {
                    show: true,
                    label: '任务类型',
                    key: 'EQ_taskCode',
                    tag: 'vSelect',
                    options: this.taskServiceAll.map(function(item){
                        return {
                            value: item.taskCode,
                            label: item.taskTitle
                        }
                    }),
                    props: {
                        filterable: true,
                    }
                }, {
                    show: true,
                    label: '处理状态',
                    key: 'EQ_status',
                    tag: 'vSelect',
                    options: [{
                        value: "pending",
                        label: "待处理"
                    },{
                        value: "processing",
                        label: "处理中"
                    }, {
                        value: "success",
                        label: "处理成功"
                    }, {
                        value: "failed",
                        label: "处理失败"
                        // }, {
                        //     value: "cancel",
                        //     label: "已取消"
                    }],
                }, {
                    show: true,
                    label: '关联单号',
                    key: 'EQ_sourceNo',
                    tag: 'vInput',
                }, {
                    label: '任务编号',
                    key: 'EQ_taskNo',
                    tag: 'vInput',
                }, {
                    label: '项目',
                    key: 'CN_lineId',
                    tag: 'vSelect',
                    options:this.products.map(function(item){
                        return {
                            value: item.name,
                            label: item.name
                        }
                    }),
                    props: {
                        filterable: true,
                    }
                }, {
                    label: '渠道',
                    key: 'CN_accountId',
                    tag: 'vSelect',
                    options: this.accounts.map(function(item){
                        return {
                            value: item.flag,
                            label: item.flag
                        }
                    }),
                    props: {
                        filterable: true,
                    }
                }, {
                    label: '仓库',
                    key: 'CN_orgWarehouseId',
                    tag: 'vSelect',
                    options: this.warehouseList.map(function(item){
                        return {
                            value: item.code,
                            label: item.code
                        }
                    }),
                    props: {
                        filterable: true,
                    }
                }, {
                    label: '创建时间',
                    key: 'BT_createdAt',
                    tag: 'vDatepicker',
                    style: "width:362px",
                    props: {
                        placeholder: "Select date",
                        format: 'yyyy-mm-dd 00:00:00 ~ yyyy-mm-dd 23:59:59',
                        confirm: false,
                    }
                },{
                    label: '创建人',
                    key: 'EQ_createdName',
                    tag: 'vInput',
                },
            ]
        },

        columns() {
            return [{
                width: 60,
                align: 'center',
                type: "selection",
                formName: 'id',
            },
                {
                    title: "操作",
                    width: 100,
                    render:this.getOperateNodes,
                },
                {
                    title: "任务编号",
                    key: "taskNo",
                },
                {
                    title: '关联单据号',
                    key: 'sourceNo',
                    align: 'center',
                    render: (h, { row }) => {
                        return row.sourceNo == null ? '--' : row.sourceNo
                    }
                },
                {
                    title: "任务类型",
                    key: "taskCode",
                    render: (h, { row }) => {
                        const code = row.taskCode;
                        const task = this.taskServiceAll.filter((item) => {
                            return code == item.taskCode
                        })[0];
                        return task.taskTitle

                    }
                },
                {
                    title: "处理状态",
                    width: 90,
                    align: 'center',
                    key: "status",
                    render: (h, { row }) => {
                        switch (row.status) {
                            case 'pending': return <vButton class="b2cspan-info span-padding">待处理</vButton>; break;
                            case 'processing': return <vButton class="b2cspan-warning span-padding">处理中</vButton>; break;
                            case 'success': return <vButton class="b2cspan-success span-padding">处理成功</vButton>; break;
                            case 'failed': return <vButton class="b2cspan-error span-padding">处理失败</vButton>; break;
                            // case 'cancel': return <vButton class="b2cspan-info span-padding">已取消</vButton>; break;
                        }
                    }
                },
                {
                    title: "异常原因",
                    key: "errorMsg",
                    align: 'center',
                    render: (h, { row }) => {
                        return row.errorMsg == null ? '--' : row.errorMsg
                    }
                },
                {
                    title: "任务输出",
                    key: "taskFile",
                    align: 'center',
                    render: (h, { row }) => {
                        if(row.taskFile == null){
                            return '--';
                        }else {
                            return <div><a onClick={this.handleOperates.bind(this, row.taskFile, 'down')}>文件下载</a></div>;
                            // return <div><a href={row.taskFile}>文件下载</a></div>;
                        }
                    }
                },
                {
                    title: "创建时间",
                    key: "createdAt",
                }]
        },

    },

};
